import { ThemeProvider } from '@mui/material/styles'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { QueryClientProvider } from '@tanstack/react-query'
import { AppErrorBoundary } from '@/components/AppErrorBoundary'
import { getGoogleClientId } from '@/config/env'
import { queryClient } from '@/query/queryClient'
import muiTheme from '@/theme/muiTheme'

/**
 * Root provider stack for the SPA (query, theme, error boundary).
 * Router lives outside in main.jsx via RouterProvider.
 *
 * @param {{ children: import('react').ReactNode }} props
 */
export default function AppProviders({ children }) {
  const googleClientId = getGoogleClientId()
  const tree = (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={muiTheme}>
        <AppErrorBoundary>{children}</AppErrorBoundary>
      </ThemeProvider>
    </QueryClientProvider>
  )

  if (googleClientId) {
    return <GoogleOAuthProvider clientId={googleClientId}>{tree}</GoogleOAuthProvider>
  }

  return tree
}
